import { render, staticRenderFns } from "./DesktopContainer.vue?vue&type=template&id=5211d40e&scoped=true"
import script from "./DesktopContainer.vue?vue&type=script&lang=js"
export * from "./DesktopContainer.vue?vue&type=script&lang=js"
import style0 from "./DesktopContainer.vue?vue&type=style&index=0&id=5211d40e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5211d40e",
  null
  
)

export default component.exports